









































import Vue from "vue";
import ApiService from "@/services/ApiService";
export default Vue.extend({
  components: {},
  data() {
    return {
      messages: [],
    };
  },
  methods: {
    withoutHtml(message) {
      return message.replace(/(<([^>]+)>)/gi, "").substring(0, 50);
    },
    getAdminMessages() {
      ApiService.generalApi.getAdminMessages().then((resp) => {
        this.messages = resp.data.messages;
        this.$store.dispatch("updateUnreadCount", resp.data.unread);
      });
    },
    setAsRead(item) {
      ApiService.generalApi.setAdminMessageAsRead(item.id).then((resp) => {
        this.getAdminMessages();
      });
    },
  },
  mounted() {
    this.getAdminMessages();
  },
});
